import { ResetPassword } from "../../components/reset-password";
import { ScreenLayout } from "../../layout/components";
import { RootStackScreenProps } from "../../navigation/Navigation.types";

export default function ResetPasswordScreen({ route }: RootStackScreenProps<"reset-password">) {
  return (
    <ScreenLayout>
      <ResetPassword
        title="Reset Password"
        authParams={route.params}
        body={"Password reset was requested for email {{email}}.\nPlease set new password and proceed."}
      />
    </ScreenLayout>
  );
}
